module.exports = __webpack_public_path__ + "static/02.c86a3f5e.png";